<template>

	<nav 
		class="relative w-full md:w-auto md:ml-6 grid grid-cols-2 md:grid-cols-1 place-content-end items-start"
		v-click-away="onClickAway"
	>
		<span :class="showMenu ? 'hidden' : 'flex'"></span>
		<ul class="w-full flex-col mt-16 space-y-4 text-white md:space-x-6 md:flex 
			md:w-auto 
            md:space-y-0
            md:flex-row
            md:items-center
            md:mt-0"
            :class="showMenu ? 'flex' : 'hidden'"
            @click="hideNav"
            >

			<li>
				<NavLink 
					href="/" 			
					:active="$page.component === 'Home'"
				>
					Home
				</NavLink>
			</li>
			<li>
			<Menu>
			    <MenuButton 
			        v-slot="{ open }"
			    	:class='{ "font-bold" : ["Areas","Graves","Grave","Famous","Bezoekersbijdragen","Person","Search/Form"].includes( $page.component ) }'
			    	class="inline-flex items-center text-sm hover:underline"
			    >
			    	<span 
			    		class="mr-1">Graven</span>
			    	
          			<svg 
          			xmlns="http://www.w3.org/2000/svg" 
          			class="h-5 w-5 transition ease-out" 
          			:class='{ "transform rotate-180 duration-100" : !open , "duration-300" : open }'
          			viewBox="0 0 20 20" 
          			fill="currentColor">
					  	<path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clip-rule="evenodd" />
					</svg>
		      	</MenuButton>
			<!-- Use Vue's built-in <transition> element to add transitions. -->
			    <transition
			      enter-active-class="transition duration-200 ease-out"
			      enter-from-class="transform scale-75 opacity-0"
			      enter-to-class="transform scale-100 opacity-100"
			      leave-active-class="transition duration-100 ease-out"
			      leave-from-class="transform scale-100 opacity-100"
			      leave-to-class="transform scale-75 opacity-0"
			    >
				    <MenuItems class="z-10 origin-top-left absolute shadow-md rounded-lg flex flex-col focus:outline-none mt-2 divide-y "
				    	:class="isExpo ? ' bg-green-100 text-green-900 divide-green-200':' bg-blue-100 text-blue-900 divide-blue-200'"
				    >
				    	<div class="px-1 py-1">
						    <MenuItem v-slot="{ active }">
						        <NavLink 
						        	:class='{ "bg-blue-500": (active && !isExpo) , "bg-green-500": (active && isExpo) , "hover:bg-blue-700" : !isExpo , "hover:bg-green-700" : isExpo }' 
						        	class="flex items-center w-full px-2 py-2 rounded-md hover:text-white" 
						        	href="/graven"
						        	:active='["Areas","Graves","Grave","Person"].includes( $page.component )'
						        	>
						        	<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
		  								<path fill-rule="evenodd" d="M10.496 2.132a1 1 0 00-.992 0l-7 4A1 1 0 003 8v7a1 1 0 100 2h14a1 1 0 100-2V8a1 1 0 00.496-1.868l-7-4zM6 9a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm3 1a1 1 0 012 0v3a1 1 0 11-2 0v-3zm5-1a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1z" clip-rule="evenodd" />
									</svg>
									<span class="ml-2">Kapellen, beuken en koren</span>
						        </NavLink>
						    </MenuItem>
						    <MenuItem v-slot="{ active }">
						        <NavLink 
						        	:class='{ "bg-blue-500": (active && !isExpo) , "bg-green-500": (active && isExpo) , "hover:bg-blue-700" : !isExpo , "hover:bg-green-700" : isExpo }' 
						        	class="flex items-center w-full px-2 py-2 rounded-md hover:text-white" 
						        	href="/graven/beroemde-namen"
						        	:active='["Famous"].includes( $page.component )'
						        	>
						        	<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
									 	<path fill-rule="evenodd" d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" clip-rule="evenodd" />
									</svg>
									<span class="ml-2">Beroemde namen</span>
						        </NavLink>
						    </MenuItem>
						    <MenuItem v-slot="{ active }">
						        <NavLink 
						        	:class='{ "bg-blue-500": (active && !isExpo) , "bg-green-500": (active && isExpo) , "hover:bg-blue-700" : !isExpo , "hover:bg-green-700" : isExpo }' 
						        	class="flex items-center w-full px-2 py-2 rounded-md hover:text-white" 
						        	href="/graven/bezoekersbijdragen"
						        	:active='["Bezoekersbijdragen"].includes( $page.component )'
						        	>
						        	<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
		  								<path fill-rule="evenodd" d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z" clip-rule="evenodd" />
									</svg>
									<span class="ml-2">Bezoekersbijdragen</span>
						        </NavLink>
						    </MenuItem>
						</div>
						<div class="px-1 py-1">
						    <MenuItem v-slot="{ active }">
						        <NavLink 
						        	:class='{ "bg-blue-500": (active && !isExpo) , "bg-green-500": (active && isExpo) , "hover:bg-blue-700" : !isExpo , "hover:bg-green-700" : isExpo }' 
						        	class="flex items-center w-full px-2 py-2 rounded-md hover:text-white" 
						        	href="/graven/zoeken"
						        	:active='["Search/Form"].includes( $page.component )'
						        	>
						        	<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
										<path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
									</svg>
									<span class="ml-2">Uitgebreid zoeken</span>
						        </NavLink>
						    </MenuItem>
						</div>
				    </MenuItems>
				</transition>
			  </Menu>
			</li>

			<li>
				<NavLink href="/exposities"
					class="whitespace-nowrap"
					:active="$page.component.startsWith('Expo')"
				>Virtuele Exposities</NavLink>
			</li>


			<li>
				<Menu>
			    <MenuButton 
			        v-slot="{ open }"
			    	:class='{ "font-bold" : ["Info/OverHetProject","Info/KerkEnStad","Info/Geschiedenis","Info/Handleiding","Info/BezoekerMedewerker"].includes( $page.component ) }'
			    	class="inline-flex items-center text-sm hover:underline"
			    >
			    	<span 
			    		class="mr-1">Over
			    	</span>
          			<svg 
          			xmlns="http://www.w3.org/2000/svg" 
          			class="h-5 w-5 transition ease-out" 
          			:class='{ "transform rotate-180 duration-100" : !open , "duration-300" : open }'
          			viewBox="0 0 20 20" 
          			fill="currentColor">
					  	<path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clip-rule="evenodd" />
					</svg>
		      	</MenuButton>
			<!-- Use Vue's built-in <transition> element to add transitions. -->
			    <transition
			      enter-active-class="transition duration-200 ease-out"
			      enter-from-class="transform scale-75 opacity-0"
			      enter-to-class="transform scale-100 opacity-100"
			      leave-active-class="transition duration-100 ease-out"
			      leave-from-class="transform scale-100 opacity-100"
			      leave-to-class="transform scale-75 opacity-0"
			    >
				    <MenuItems 
				    	class="z-10 origin-top-left absolute shadow-md rounded-lg flex flex-col focus:outline-none mt-2 divide-y "
				    	:class="isExpo ? ' bg-green-100 text-green-900 divide-green-200':' bg-blue-100 text-blue-900 divide-blue-200'"
				    >
				    	<div class="px-1 py-1">
						    <MenuItem v-slot="{ active }">
						        <NavLink 
						        	:class='{ "bg-blue-500": (active && !isExpo) , "bg-green-500": (active && isExpo) , "hover:bg-blue-700" : !isExpo , "hover:bg-green-700" : isExpo }' 
						        	class="flex items-center w-full px-2 py-2 rounded-md hover:text-white" 
						        	href="/info"
						        	:active='["Info/OverHetProject"].includes( $page.component )'
						        	>
									<span class="">Over het project</span>
						        </NavLink>
						    </MenuItem>
						    <MenuItem v-slot="{ active }">
						        <NavLink 
						        	:class='{ "bg-blue-500": (active && !isExpo) , "bg-green-500": (active && isExpo) , "hover:bg-blue-700" : !isExpo , "hover:bg-green-700" : isExpo }' 
						        	class="flex items-center w-full px-2 py-2 rounded-md hover:text-white" 
						        	href="/info/kerk-en-stad"
						        	:active='["Info/KerkEnStad"].includes( $page.component )'
						        	>
									<span class="">Kerk en stad</span>
						        </NavLink>
						    </MenuItem>
						    <MenuItem v-slot="{ active }">
						        <NavLink 
						        	:class='{ "bg-blue-500": (active && !isExpo) , "bg-green-500": (active && isExpo) , "hover:bg-blue-700" : !isExpo , "hover:bg-green-700" : isExpo }' 
						        	class="flex items-center w-full px-2 py-2 rounded-md hover:text-white" 
						        	href="/info/geschiedenis"
						        	:active='["Info/Geschiedenis"].includes( $page.component )'
						        	>
									<span class="">Geschiedenis databank</span>
						        </NavLink>
						    </MenuItem>
						    <MenuItem v-slot="{ active }">
						        <NavLink 
						        	:class='{ "bg-blue-500": (active && !isExpo) , "bg-green-500": (active && isExpo) , "hover:bg-blue-700" : !isExpo , "hover:bg-green-700" : isExpo }' 
						        	class="flex items-center w-full px-2 py-2 rounded-md hover:text-white" 
						        	href="/info/handleiding"
						        	:active='["Info/Handleiding"].includes( $page.component )'
						        	>
									<span class="">Handleiding databank</span>
						        </NavLink>
						    </MenuItem>
						    <MenuItem v-slot="{ active }">
						        <NavLink 
						        	:class='{ "bg-blue-500": (active && !isExpo) , "bg-green-500": (active && isExpo) , "hover:bg-blue-700" : !isExpo , "hover:bg-green-700" : isExpo }' 
						        	class="flex items-center w-full px-2 py-2 rounded-md hover:text-white" 
						        	href="/info/bezoeker-als-medewerker"
						        	:active='["Info/BezoekerMedewerker"].includes( $page.component )'
						        	>
									<span class="">De bezoeker als medewerker</span>
						        </NavLink>
						    </MenuItem>
						</div>
				    </MenuItems>
				</transition>
			  </Menu>
			</li>

			<li>
				<NavLink href="/colofon"
					:active="$page.component === 'Info/Colofon'"
					>
					Colofon
				</NavLink>
			</li>

			<li class="">
				<div @click.stop="toggleSearch" class="hidden md:visible search-icon cursor-pointer px-4 md:flex items-center justify-self-end">
			        <svg class="fill-current pointer-events-none text-grey-darkest w-4 h-4 inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
						<path d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"></path>
					</svg>
		    	</div>
			</li>

			<li v-if="username">
				<a 
				class="hover:underline text-sm"
				href="/admin" 
				>CMS</a>
			</li>

			<li v-if="username">
				<NavLink 
				href="/admin/logout" 
				method="post" 
				as="button"
				>Log out</NavLink></li>
		</ul>
		
		<!-- Mobile menu button -->
		<div class="md:hidden flex items-center justify-self-end">
			<div 
			@click.stop="toggleSearch" 
			class="search-icon cursor-pointer px-4 flex items-center justify-self-end">
		        <svg class="fill-current pointer-events-none text-grey-darkest w-4 h-4 inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
					<path d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"></path>
				</svg>
		    </div>
			<button @click.stop="toggleNav" class="outline-none mobile-menu-button">
				<svg class=" w-6 h-6 text-white hover:text-blue-900 "
					x-show="!showMenu"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path d="M4 6h16M4 12h16M4 18h16"></path>
				</svg>
			</button>
		</div>

		 <!--Search-->
    <div 

    	v-show="showSearch"
    	class="right-0 top-14 w-100 bg-white shadow-xl" 
    	id="search-content">
      <div class="absolute container mx-auto py-2 text-black">
        <form @submit.prevent="submitSearch">
        	<input 
        		v-model="keyword" 
        		v-click-away="hideSearch"
        		id="keyword" 
        		type="search" 
        		placeholder="zoek op trefwoord..." 
        		autofocus="autofocus" 
        		class="rounded w-full text-grey-800 transition focus:outline-none focus:border-transparent p-2 appearance-none leading-normal text-lg lg:text-xl">
        </form>
      </div>

    </div>
	</nav>


   

</template>

<script>
import NavLink from './NavLink';
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { Inertia } from "@inertiajs/inertia";
import { mixin as VueClickAway } from "vue3-click-away";

export default {
	components: { 
		NavLink , 
		Menu,
    	MenuButton,
    	MenuItems,
    	MenuItem,
	},
	mixins: [VueClickAway],
	data() {
		return {
			showMenu: false,
			showSearch: false,
			keyword: '',
		};
	},
	methods: {
		toggleNav: function() {
			this.showMenu = !this.showMenu;
		},
		toggleSearch: function() {
			// console.log( "klik op search icon: " + this.showSearch);
			this.showSearch = !this.showSearch;
		},
		hideNav: function() {
			this.showMenu = false;
		},
		hideSearch: function() {
			this.showSearch = false;
		},
		onClickAway(event) {
      		// console.log("test: "+ event);
      		this.showMenu = false;
    	},
    	submitSearch() {
    	  this.showSearch = false;
    	  this.keyword = '';
		  Inertia.get( '/graven/zoeken' , {keyword:keyword.value, scope:1, page:1} , { preserveState: false , replace: true } );
		}
	},
	computed: {
		username() {
			return this.$page.props.auth.user.username;
		},
		isExpo() {
			// console.log('is dit een expo? ' + this.$page.props.isExpo);		
			return this.$page.props.isExpo;
		},
	}
};
</script>